import { Resource } from "@redotech/util/resource";
import { sleep } from "@redotech/util/schedule";
import JSZip from "jszip";
import { withObjectUrl } from "./url";

function withDownloadLink(
  url: string,
  filename?: string,
): Resource<HTMLAnchorElement> {
  return async (fn) => {
    const element = document.createElement("a");
    element.download = filename || "";
    element.href = url;
    element.style.display = "none";
    document.body.append(element);
    try {
      return await fn(element);
    } finally {
      element.remove();
    }
  };
}

export async function downloadBlob(blob: Blob, filename?: string) {
  console.log("Downloading");
  await withObjectUrl(blob)((url) =>
    withDownloadLink(
      url,
      filename,
    )(async (element) => {
      element.click();
      await sleep(new Temporal.Duration());
    }),
  );
}

export async function downloadUrl(url: string, filename?: string) {
  console.log("Downloading from URL");
  await withDownloadLink(
    url,
    filename,
  )(async (element) => {
    element.click();
    await sleep(new Temporal.Duration());
  });
}

/**
 * Attribute `download` is silently ignored when the URL is not same-origin,
 * so we need to fetch the file as a blob and create an object URL for it to work.
 */
export async function downloadUrlAsBlob(url: string, filename?: string) {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to fetch ${url}: ${response.statusText}`);
  }
  const blob = await response.blob();
  await downloadBlob(blob, filename);
}

// @ts-expect-error unused-export-debt
async function downloadBlobsAsZip(
  files: { name: string; blob: Blob }[],
  zipName: string,
): Promise<void> {
  const zip = new JSZip();

  for (const file of files) {
    zip.file(file.name, file.blob);
  }

  const zipBlob = await zip.generateAsync({ type: "blob" });
  await downloadBlob(zipBlob, zipName);
}
